import * as Yup from 'yup';
const shareDemoInviteValidationSchema = Yup.object().shape({
  conferenceLink: Yup.string().required('Please enter the conference link'),
  demoDate: Yup.string().required('Please enter the demo date'),
  demoTime: Yup.string().required('Please enter the demo time')
});

export default shareDemoInviteValidationSchema;
